module.exports = __webpack_public_path__ + "static/media/Pacesetter.5af7eb5a.svg";